// third-party
import { FormattedMessage } from 'react-intl';

// material-ui
import { Link, Typography } from '@mui/material';

// ==============================|| POWERED BY ||============================== //

const PoweredBy = () => (
  <Typography variant="caption" color="textSecondary" component="span">
    <FormattedMessage id="footer.poweredBy" />{' '}
    <Link
      href="https://uzdevid.com"
      target="_blank"
      // `noopener` keeps the new tab from reaching back through `window.opener`; `noreferrer` stops
      // the console URL leaking as a referrer.
      rel="noopener noreferrer"
      underline="hover"
      color="primary"
    >
      UzDevid
    </Link>
  </Typography>
);

export default PoweredBy;
